export default __webpack_public_path__ + "static/media/tex-gyre-adventor-bold.76bb4f17.woff";